import { render, staticRenderFns } from "./HideBoardsModal.vue?vue&type=template&id=5d9bd360&"
import script from "./HideBoardsModal.vue?vue&type=script&lang=js&"
export * from "./HideBoardsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports